var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcChevronCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03113 11.8461L15.5618 2.8125L16.875 4.20197L7.03113 14.625L1.125 8.37138L2.43727 6.98191L7.03113 11.8461Z",
    fill: "#10DB9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChevronCheckGreen);
export default __webpack_public_path__ + "static/media/ic_chevron_check_green.13ae894f5176905bb1b08b39dc398db5.svg";
export { ForwardRef as ReactComponent };